import React from 'react'
import { useTranslation } from 'react-i18next'

import { BaseModalType } from '@context/ModalsContext'

import { Modal } from '@ui/components/Modal'

export const ConfirmTurnOffTwoFactorAuthenticationModal: BaseModalType<{
  onConfirm: () => void
}> = ({ onConfirm, close }) => {
  const { t } = useTranslation()
  return (
    <Modal>
      <Modal.Header>{t('Warning')}</Modal.Header>
      <Modal.Body>
        <Modal.Body.Text>
          <span
            dangerouslySetInnerHTML={{
              __html: t(
                'Profile.We advise you not to turn off your Two-Factor authentication (2FA) or any of the enabled methods, as that will remove the extra layer of security the 2FA adds to your Client Area'
              ),
            }}
          />
        </Modal.Body.Text>
      </Modal.Body>
      <Modal.Footer>
        <Modal.Footer.Secondary onClick={close}>{t('Cancel')}</Modal.Footer.Secondary>
        <Modal.Footer.Primary
          onClick={() => {
            onConfirm()
            close()
          }}
        >
          {t('Profile.Accept the risk')}
        </Modal.Footer.Primary>
      </Modal.Footer>
    </Modal>
  )
}
